import ComponentModule from "@eisinc/Overrides/Components/CustomerCard";

export * from "@eisinc/Overrides/Components/CustomerCard";

export default ComponentModule;
